import create from "zustand"
import {
  Challenge,
  LiveNotification,
  Task
} from "../sdk"
import { ChallengeStore, CurrentOpenSubscriptionType, DefaultStateType, SubmissionsType, SubscriptionsType } from "../types/challenge-store"

const defaultState: DefaultStateType = {
  challenge: null,
  tasks: null,
  notifications: null,
  subscriptions: null,
  subscriptionsTableVisible: true,
  submissions: null,
  currentOpenSubscription: null
}

export const useChallenge = create<ChallengeStore>((set) => ({
  challenge: null,
  tasks: null,
  notifications: null,
  subscriptions: null,
  subscriptionsTableVisible: true,
  submissions: null,
  currentOpenSubscription: null,
  setChallenge: (challenge: Challenge | null): void => set({ challenge }),
  setTasks: (tasks: Task[]): void => set({ tasks }),
  setNotifications: (notifications: LiveNotification[] | null): void => set({ notifications }),
  setSubscriptions: (subscriptions: SubscriptionsType): void => set({ subscriptions }),
  setSubscriptionsTableVisible: (value: boolean): void => set({ subscriptionsTableVisible: value }),
  setSubmissions: (submissions: SubmissionsType): void => set({ submissions }),
  setCurrentOpenSubscription: (user: CurrentOpenSubscriptionType): void => set({ currentOpenSubscription: user }),
  reset: (): void => set((state) => ({ ...state, ...defaultState }))
}))
